export const AI_DISCLOSURE_TRIGGER_CLASS =
  'flex min-w-0 w-full items-center gap-2 py-1 text-left text-sm leading-6 text-zinc-400 transition-colors hover:text-zinc-200';

export const AI_DISCLOSURE_LABEL_CLASS =
  'min-w-0 flex-1 break-words text-sm leading-6 font-normal [overflow-wrap:anywhere]';

export const AI_DISCLOSURE_TRAILING_ICON_CLASS =
  'pointer-events-none ml-auto size-4 shrink-0 text-muted-foreground/70 opacity-0 transition-[opacity,transform] group-hover/disclosure:opacity-100 group-focus-within/disclosure:opacity-100';

export const AI_DISCLOSURE_CONTENT_CLASS =
  'mt-1 overflow-hidden outline-none data-[state=closed]:mt-0 data-[state=closed]:h-0 data-[state=closed]:invisible data-[state=closed]:pointer-events-none';
